$(document).ready(function () {
    $('.js_blog__slider').each((i, el) => {
        new Swiper(el, {
            slidesPerView: 1,
            breakpoints: {
                568: {
                    slidesPerView: 2,
                    spaceBetween: 30
                },
                1024: {
                    slidesPerView: 3,
                    spaceBetween: 30
                }
            },
            navigation: {
                nextEl: '.js_blog__next',
                prevEl: '.js_blog__prev'
            },
            pagination: {
                el: '.js_blog__pagi',
                bulletClass: 'blog__pagi-item',
                bulletActiveClass: 'active'
            },
            modules: [SwiperModes.Navigation, SwiperModes.Pagination]
        })
    })
    blogNavPosition()
})

$(window).on('resize', function () {
    blogNavPosition()
})

function blogNavPosition() {
    $('.js_blog__slider').each((i, el) => {
        let top = $(el).find('.js_blog__img').outerHeight() / 2
        $(el).find('.js_blog__nav').css('top', top)
    })
}